"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopDefinitionModel = void 0;
/* eslint-disable max-len */
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const GradingMethod_1 = __importDefault(require("@opsbase/lib-grading/GradingMethod"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
class PopDefinitionModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.title = '';
        this.titleAlt = {};
        this.description = '';
        this.form = [];
        this.approvalRequired = false;
        this.approvalStaff = [];
        this.approvalPositions = [];
        this.approvalTeams = [];
        this.allPTsPermitted = false;
        this.positions = [];
        this.opSchedules = [];
        this.teams = [];
        this.type = 'unspecified';
        this.placesSelectedByTag = false;
        this.placesSelectedByParent = false;
        this.placeTags = [];
        this.places = [];
        this.isScoreEnabled = false;
        this.isScorePublic = false;
        this.gradingMethod = new GradingMethod_1.default();
        this.isGradingPublic = false;
        this.allowIssuesAndNotes = false;
        this.canBePerformedOnlyOnNative = false;
        if (o === null || o === void 0 ? void 0 : o.form) {
            try {
                o.form = JSON.parse(o.form || '[]'); //.map(i => new Question(i))
            }
            catch (_a) { }
        }
        super.init(o);
    }
    get __typename() {
        return 'OpDefinition';
    }
    set __typename(v) {
    }
    get scheduled() {
        return this.opSchedules.length > 0;
    }
    get canEnable() {
        return this.scheduled;
    }
    get teamsAndPositions() {
        return [...this.teams, ...this.positions];
    }
}
exports.PopDefinitionModel = PopDefinitionModel;
PopDefinitionModel.ALL_FIELDS = `id,
		title,
		opDefinitionId,
		createdDate,
		updatedDate,
		description,
		form,
		allPTsPermitted,
		orgTemplateId,
		approvalRequired,
	    approvalStaff { id, title, hasProfileImage, profileImageUrl },
	    approvalPositions { id, title },
	    approvalTeams { id, title },
		isScoreEnabled,
		isScorePublic,
		gradingMethod,
		isGradingPublic,
		allowIssuesAndNotes,
		canBePerformedOnlyOnNative,
		type,
		placesSelectedByTag,
		placesSelectedByParent,
		placeTags,
		places { id, title, timezone, tags },
		positions { id, title },
		teams { id, title }`;
exports.default = PopDefinitionModel;
ModelRegistry_1.default[DataType_1.default.POPDEFINITION] = PopDefinitionModel;
